/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import { KgNodesNavIcon } from '../knowledgeGraph/KgNodesIcon';

/**
 * Sidebar entry for the knowledge-graph fleet view (PLAT-1534). Reads are
 * open to any authenticated user (same tier as the catalog); the page itself
 * renders an empty state while the artifact store is unconfigured.
 */
export const KnowledgeGraphSidebarItem = () => (
  <SidebarItem icon={KgNodesNavIcon} to="/knowledge-graph" text="Knowledge Graph" />
);
